import { render, staticRenderFns } from "./process-item.vue?vue&type=template&id=86358186&scoped=true&"
import script from "./process-item.vue?vue&type=script&lang=js&"
export * from "./process-item.vue?vue&type=script&lang=js&"
import style0 from "./process-item.vue?vue&type=style&index=0&id=86358186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86358186",
  null
  
)

export default component.exports